// body scroll lock

// !function(e,o){if("function"==typeof define&&define.amd)define(["exports"],o);else if("undefined"!=typeof exports)o(exports);else{var t={exports:{}};o(t.exports),e.bodyScrollLock=t.exports}}(this,function(e){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=!1;if("undefined"!=typeof window){var t={get passive(){o=!0}};window.addEventListener("testPassive",null,t),window.removeEventListener("testPassive",null,t)}var n="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&(/iP(ad|hone|od)/.test(window.navigator.platform)||"MacIntel"===window.navigator.platform&&window.navigator.maxTouchPoints>1),r=[],i=!1,l=-1,d=void 0,c=void 0,a=function(e){return r.some(function(o){return!(!o.options.allowTouchMove||!o.options.allowTouchMove(e))})},u=function(e){var o=e||window.event;return!!a(o.target)||(o.touches.length>1||(o.preventDefault&&o.preventDefault(),!1))},s=function(){void 0!==c&&(document.body.style.paddingRight=c,c=void 0),void 0!==d&&(document.body.style.overflow=d,d=void 0)};e.disableBodyScroll=function(e,t){if(e){if(!r.some(function(o){return o.targetElement===e})){var s={targetElement:e,options:t||{}};r=[].concat(function(e){if(Array.isArray(e)){for(var o=0,t=Array(e.length);o<e.length;o++)t[o]=e[o];return t}return Array.from(e)}(r),[s]),n?(e.ontouchstart=function(e){1===e.targetTouches.length&&(l=e.targetTouches[0].clientY)},e.ontouchmove=function(o){1===o.targetTouches.length&&function(e,o){var t=e.targetTouches[0].clientY-l;!a(e.target)&&(o&&0===o.scrollTop&&t>0?u(e):function(e){return!!e&&e.scrollHeight-e.scrollTop<=e.clientHeight}(o)&&t<0?u(e):e.stopPropagation())}(o,e)},i||(document.addEventListener("touchmove",u,o?{passive:!1}:void 0),i=!0)):function(e){if(void 0===c){var o=!!e&&!0===e.reserveScrollBarGap,t=window.innerWidth-document.documentElement.clientWidth;o&&t>0&&(c=document.body.style.paddingRight,document.body.style.paddingRight=t+"px")}void 0===d&&(d=document.body.style.overflow,document.body.style.overflow="hidden")}(t)}}else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.")},e.clearAllBodyScrollLocks=function(){n?(r.forEach(function(e){e.targetElement.ontouchstart=null,e.targetElement.ontouchmove=null}),i&&(document.removeEventListener("touchmove",u,o?{passive:!1}:void 0),i=!1),l=-1):s(),r=[]},e.enableBodyScroll=function(e){e?(r=r.filter(function(o){return o.targetElement!==e}),n?(e.ontouchstart=null,e.ontouchmove=null,i&&0===r.length&&(document.removeEventListener("touchmove",u,o?{passive:!1}:void 0),i=!1)):r.length||s()):console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.")}});

!function(e,o){if("function"==typeof define&&define.amd)define(["exports"],o);else if("undefined"!=typeof exports)o(exports);else{var t={};o(t),e.bodyScrollLock=t}}(this,function(exports){"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var t=!1;if("undefined"!=typeof window){var e={get passive(){t=!0}};window.addEventListener("testPassive",null,e),window.removeEventListener("testPassive",null,e)}function d(o){return s.some(function(e){return!(!e.options.allowTouchMove||!e.options.allowTouchMove(o))})}function l(e){var o=e||window.event;return!!d(o.target)||(1<o.touches.length||(o.preventDefault&&o.preventDefault(),!1))}function n(){void 0!==m&&(document.body.style.paddingRight=m,m=void 0),void 0!==v&&(document.body.style.overflow=v,v=void 0)}function i(){if(void 0!==f){var e=-parseInt(document.body.style.top,10),o=-parseInt(document.body.style.left,10);document.body.style.position=f.position,document.body.style.top=f.top,document.body.style.left=f.left,window.scrollTo(o,e),f=void 0}}var c="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&(/iP(ad|hone|od)/.test(window.navigator.platform)||"MacIntel"===window.navigator.platform&&1<window.navigator.maxTouchPoints),s=[],u=!1,a=-1,v=void 0,f=void 0,m=void 0;exports.disableBodyScroll=function(r,e){if(r){if(!s.some(function(e){return e.targetElement===r})){var o={targetElement:r,options:e||{}};s=[].concat(function(e){if(Array.isArray(e)){for(var o=0,t=Array(e.length);o<e.length;o++)t[o]=e[o];return t}return Array.from(e)}(s),[o]),c?window.requestAnimationFrame(function(){if(void 0===f){f={position:document.body.style.position,top:document.body.style.top,left:document.body.style.left};var e=window,o=e.scrollY,t=e.scrollX,n=e.innerHeight;document.body.style.position="fixed",document.body.style.top=-o+"px",document.body.style.left=-t+"px",setTimeout(function(){return window.requestAnimationFrame(function(){var e=n-window.innerHeight;e&&n<=o&&(document.body.style.top=-(o+e))})},300)}}):function(e){if(void 0===m){var o=!!e&&!0===e.reserveScrollBarGap,t=window.innerWidth-document.documentElement.clientWidth;if(o&&0<t){var n=parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right"),10);m=document.body.style.paddingRight,document.body.style.paddingRight=n+t+"px"}}void 0===v&&(v=document.body.style.overflow,document.body.style.overflow="hidden")}(e),c&&(r.ontouchstart=function(e){1===e.targetTouches.length&&(a=e.targetTouches[0].clientY)},r.ontouchmove=function(e){var o,t,n,i;1===e.targetTouches.length&&(t=r,i=(o=e).targetTouches[0].clientY-a,d(o.target)||(t&&0===t.scrollTop&&0<i||(n=t)&&n.scrollHeight-n.scrollTop<=n.clientHeight&&i<0?l(o):o.stopPropagation()))},u||(document.addEventListener("touchmove",l,t?{passive:!1}:void 0),u=!0))}}else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.")},exports.clearAllBodyScrollLocks=function(){c&&(s.forEach(function(e){e.targetElement.ontouchstart=null,e.targetElement.ontouchmove=null}),u&&(document.removeEventListener("touchmove",l,t?{passive:!1}:void 0),u=!1),a=-1),(c?i:n)(),s=[]},exports.enableBodyScroll=function(o){o?(s=s.filter(function(e){return e.targetElement!==o}),c&&(o.ontouchstart=null,o.ontouchmove=null,u&&0===s.length&&(document.removeEventListener("touchmove",l,t?{passive:!1}:void 0),u=!1)),(c?i:n)()):console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.")}});


// lazy load images
var observer;
var lazyLoad = (entries, observer) => {
  entries.forEach(entry => {
    if(entry.isIntersecting){
      if(entry.target.dataset.src){
      entry.target.src = entry.target.dataset.src;
      } else if(entry.target.dataset.desktopSrc){
        if(isSmall.matches){
          entry.target.src = entry.target.dataset.mobileSrc;
        } else {
          entry.target.src = entry.target.dataset.desktopSrc;
        }
      }
      entry.target.onload = () => {
        entry.target.removeAttribute('data-lazy');
        observer.unobserve(entry.target);
      }

    }
  });
};

// check browser support

function lazyLoadInit(){
  if ('IntersectionObserver' in window) {

    observer = new IntersectionObserver(lazyLoad, {
      root: null,
      rootMargin: '0px 0px 400px 0px',
      threshold: 0
    });

    var lazyImages = document.querySelectorAll('img[data-lazy]');
    lazyImages.forEach(image => observer.observe(image));


  }  else {

    // if intersectionObserver isn't supprted, we won't lazy load images
    var lazyImages = document.querySelectorAll('img[data-lazy]'), i;

    for (i = 0; i < lazyImages.length; ++i) {
      lazyImages[i].src = lazyImages[i].dataset.src;
    }

  }
}

lazyLoadInit();

// newsletter popup

if(localStorage.getItem('styrkr-newsletter-status') != 'registered'){
  let newsletterPopupTimer = localStorage.getItem('styrkr-newsletter-popup-timer');
  if(newsletterPopupTimer){
    let currentDate = Date.now();
    let ellapsed = currentDate - newsletterPopupTimer;
    if(ellapsed > 172800000){
       //popupNewsletter(false)
    };
    // note: 172800000 = 2 days
  } else {
    localStorage.setItem('styrkr-newsletter-popup-timer', Date.now());
    //popupNewsletter(false);
  }
}// cart functions

function getDefaultRequestConfig() {
  return JSON.parse(
    JSON.stringify({
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    })
  );
}

function fetchJSON(url, config) {
  return fetch(url, config).then(function(response) {
    if (!response.ok) {
      throw response;
    }
    return response.json();
  });
}


async function fetchJSONPromise(url, config) {
  const response = await fetch(url, config);
  return response.json();
}

function cart() {
  return fetchJSON('/cart.js', getDefaultRequestConfig());
}

async function cartAdd(id, quantity, sellingPlan, properties) {
  var config = getDefaultRequestConfig();

  config.method = 'POST';
  config.body = JSON.stringify({
    id: id,
    quantity: quantity,
    properties: properties,
    selling_plan: sellingPlan
  });

  return await fetchJSONPromise(`${window.Shopify.routes.root}cart/add.js`, config);

}

async function cartAddMultiple(items) {
  var config = getDefaultRequestConfig();

  config.method = 'POST';
  config.body = JSON.stringify({items: items});

  return await fetchJSONPromise(`${window.Shopify.routes.root}cart/add.js`, config);

}

async function cartChange(line, quantity) {
  var config = getDefaultRequestConfig();

  config.method = 'POST';
  config.body = JSON.stringify({
    id: line,
    quantity: Number(quantity),
  });

  return await fetchJSONPromise(`${window.Shopify.routes.root}cart/change.js`, config);

  
}

// shopify image sizer

function getSizedImageUrl(src, size) {
  if (size === null) {
    return src;
  }

  if (size === 'master') {
    return removeProtocol(src);
  }

  const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

  if (match) {
    const prefix = src.split(match[0]);
    const suffix = match[0];

    return removeProtocol(`${prefix[0]}_${size}${suffix}`);
  } else {
    return null;
  }
}

function removeProtocol(path) {
  return path.replace(/http(s)?:/, '');
}

// media query setup
var isSmall = window.matchMedia('(max-width: 875px)');
var isTablet = window.matchMedia('(min-width: 40em) and (max-width: 63.9375em)');
var isMobile = window.matchMedia('(max-width: 39.9375em)');
var isHome = document.querySelector('body.index');

// update media query on resize
window.addEventListener('resize', () => {
  isSmall = window.matchMedia('(max-width: 875px)');
  isTablet = window.matchMedia('(min-width: 40em) and (max-width: 63.9375em)');
  isMobile = window.matchMedia('(max-width: 39.9375em)');
  // check scroll event listener again
  headerEvents();
});

// query selectors
var mobileMenuButton = document.querySelector('#mobile-menu-button');
var header = document.querySelector('#shopify-section-header');
var scrollShift = 0;
if(document.querySelector('.notification-banner')){
  scrollShift = -34;
} else {
  scrollShift = -0;
}
var menu = document.querySelector('.main-menu');
var secondaryMenu = document.querySelector('.secondary-menu');
var bodyDarken = document.querySelector('.body-darken');
var searchContainer = document.querySelector('.search-container');
var searchBox = document.querySelector('#search');
var cartDrawer = document.querySelector('#cart');
var filters = document.querySelector('.filter-container .large-2');

var haveMoved = false;
var mobileMenuListenerAdded = false;
var isOpen;
var bodyWidth = 0;

const currentCurrency = document.getElementById('current-currency').innerHTML;

// global toggle event
bodyDarken.addEventListener('click', e => toggleElement(isOpen, e));

var currentScrollPosition;

function toggleElement(elem, e){
  e.preventDefault();
  e.stopPropagation();
  
  if(elem == menu){
     mobileMenuToggle();
    if(document.querySelector('body').classList.contains('open')){
      toggleElement(document.querySelector('body'), e);
    }
  }

  if(elem.classList.contains('open')){
    bodyScrollLock.enableBodyScroll(elem);
    if(elem == cartDrawer || elem == filters || elem == menu){
      document.body.classList.remove('fixed-body');
      window.scrollTo(0, currentScrollPosition);
    }
    elem.classList.remove('open');
    bodyDarken.classList.remove('enabled');
    isOpen = false;
    elem.tabIndex = -1;
    elem.blur();
  } else {
    currentScrollPosition = window.pageYOffset;
    bodyScrollLock.disableBodyScroll(elem, {
      allowTouchMove: el => {
        while (el && el !== document.body) {
          if (el.getAttribute('body-scroll-lock-ignore') !== null) {
            return true;
          }
    
          el = el.parentElement;
        }
      },
    });
    bodyDarken.classList.add('enabled');
    elem.classList.add('open');
    elem.tabIndex = 0;
    elem.focus();
    isOpen = elem;
    if(e.target){
      e.target.blur();
    }
    if(elem == cartDrawer || elem == filters){
      document.body.classList.add('fixed-body');
    }
  }
}

// responsive listeners and element positions

function headerEvents(){
  var newWidth = window.innerWidth;
  if(newWidth != bodyWidth){
    if(isSmall.matches){
      // remove event to hide notification bar on scroll
        // document.removeEventListener('scroll', headerScroll, {passive: true});
      // move the secondary menu items on mobile
      if(haveMoved === false){
        if(menu) document.querySelector('body').appendChild(menu);
        if(searchContainer) document.querySelector('body').appendChild(searchContainer); 
        haveMoved = true;
      }
      // ensure header is no longer transformed
      if(header) header.style.top = '33px';
      // position and height of slide out menu
        // menu.style.top = (header.offsetHeight - 1) + 'px';
        // menu.style.height = 'calc(100vh - ' + (header.offsetHeight + 33 - 1) + 'px)';
      // add event to open menu on hambuger click mobile
      if(!mobileMenuListenerAdded){
        if(mobileMenuButton && document.querySelector('.toggle-main-menu')){
          mobileMenuButton.addEventListener('click' , e => {
            toggleElement(menu, e);
          });
          document.querySelector('.toggle-main-menu').addEventListener('click' , e => {
            toggleElement(menu, e);
          });
        }
        mobileMenuListenerAdded = true;
      }
      // add event to open sub-menu items on mobile menu
      document.querySelectorAll('.main-menu a.has-child svg').forEach(subMenuParent => subMenuParent.removeEventListener('click', desktopOpenSubMenu));
      document.querySelectorAll('.main-menu a.has-child').forEach(subMenuParent => subMenuParent.addEventListener('click', mobileOpenSubMenu));
      
  } else {
    // position mega menu
    document.querySelectorAll('.mega-menu').forEach(megaMenu => megaMenu.style.top = header.offsetHeight + "px");
    // reset menu position
    if(menu) menu.style.top = '0px';
    // add event to hide notification bar on scroll
      // document.addEventListener('scroll', headerScroll, {passive: true});
    // remove event to open sub-menu for mobile
    document.querySelectorAll('.main-menu a.has-child').forEach(subMenuParent => subMenuParent.removeEventListener('click', mobileOpenSubMenu));
    document.querySelectorAll('.main-menu a.has-child svg').forEach(subMenuParent => subMenuParent.addEventListener('click', desktopOpenSubMenu));
    // return the secondary menu items on back on desktop
    if(haveMoved){
        if(menu) document.querySelector('.header-container').appendChild(menu);
        if(searchContainer) document.querySelector('header').appendChild(searchContainer);
        haveMoved = false;
      }
    }
  
    bodyWidth = newWidth;
  }

  let cartWidth = cartDrawer.offsetWidth;
  cartDrawer.style.transform = 'translateX(' + cartWidth + 'px)';

  positionMarkers();
  setTimeout(positionMarkers, 2000);
  
  // add event to hide notification bar on scroll
  // document.addEventListener('scroll', headerScroll, {passive: true});
  
}

function positionMarkers(){
  // organise the upsell markers
  if(document.querySelector('.delivery-target-container')){
    let markersData = JSON.parse(document.querySelector('#markers-data').innerHTML).upsells;
    if(markersData.length < 1){
      document.querySelector('.delivery-target-container').style.display = 'none';
      return;
    }
    let maxValue = Math.max(...markersData.map(marker => marker.threshold))
    // sort by value
    markersData.sort((a, b) => a.threshold - b.threshold);
    markersData.forEach((marker, index) => {
        let markerElement = document.getElementById(marker.id);
        let position = ((index + 1) / (markersData.length + 1)) * 100;
        let elementWidth = markerElement.offsetWidth;
        elementWidth = elementWidth > 100 ? 85 : elementWidth;
        if(position === 100){
          markerElement.classList.add('end-marker');
          markerElement.style.right = '0';
        } else {
          markerElement.style.right = `calc(${100 - position}% - ${elementWidth / 2}px)`;
        }
    })
  }
}

// ready transform, to avoid slide out on load
if(menu) menu.classList.add('ready-to-translate');
cartDrawer.classList.add('ready-to-translate');
if(filters){
  filters.classList.add('ready-to-translate');
}

// first setup, repeated on resize
headerEvents();

// scroll event – hide notification bar
function headerScroll(){
  if(window.scrollY > 50){
   if(header) header.style.top = scrollShift + 'px';
    if(isSmall.matches){
      // menu.style.height = 'calc(100vh - ' + (header.offsetHeight + scrollShift) + 'px)';
    }
  } else{
   if(header) header.style.top = '0px';
    if(isSmall.matches){
      // menu.style.height = 'calc(100vh - ' + header.offsetHeight + 'px)';
    }
  }
}

// toggle mobile menu icon
function mobileMenuToggle(){
  if(mobileMenuButton){
    // close if already open
    if(mobileMenuButton.classList.contains('is-active')){
      mobileMenuButton.classList.remove('is-active');
    } else {
      mobileMenuButton.classList.add('is-active');
    }
  }
}

function mobileOpenSubMenu(e){
  let subMenu = e.currentTarget.previousSibling;
  let clicked = e.currentTarget;
  if(subMenu.classList.contains('open')){
    if(e.target.nodeName !== 'A'){
      e.preventDefault();
      subMenu.classList.remove('open');
      clicked.classList.remove('open');
    }
  } else {
    e.preventDefault();
    clicked.classList.add('open');
    subMenu.classList.add('open');
  }
}

function desktopOpenSubMenu(e){
  e.preventDefault();
}

// handle expandable sections that use //read-more

function toggleMore(e){
  e.preventDefault();
  e.stopPropagation();
  let link = e.currentTarget;
  let truncated = link.previousElementSibling.previousElementSibling;
  let fullText = link.previousElementSibling;
  if(link.classList.contains('active')){
    // trigger read less
    link.classList.remove('active');
    link.textContent = 'Read more';
    truncated.classList.remove('hide');
    fullText.classList.add('hide');
  } else {
    // trigger read more
    link.classList.add('active');
    link.textContent = 'Read less';
    truncated.classList.add('hide');
    fullText.classList.remove('hide');
  }
  
}

if(document.querySelector('.read-more-link')){
  document.querySelectorAll('.read-more-link').forEach(link => {
    link.addEventListener('click', toggleMore);
  });
};                                                       

// predictive search

if(searchBox){
  searchContainer.querySelector('svg').addEventListener('click', () => {
    if(searchBox.value == ''){
      searchBox.focus();
    } else {
      document.querySelector('#search-button').click();
    }
  });
  searchBox.addEventListener('input', predictiveSearch);
  searchBox.addEventListener('blur', () =>{
    setTimeout( () => document.querySelector('.predictive-search-results').style.display = 'none', 300);
  });
}
  
var searchTimeout;

// throttle the input listener
var throttleFunction = function(func, searchTerm, delay) {
	// if already running, do nothing
	if (searchTimeout) {
		return
	}

	//  setTimeout after delay seconds
    searchTimeout = setTimeout( () => {
      func(searchTerm);
      searchTimeout = undefined;
    }, delay);
}

// get search json
function searchJSON(searchTerm){
  if(searchTerm == ''){
    displayPredictiveSearch('');
    return;
  }
  fetch("/search/suggest.json?q=" + searchTerm + "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last")
  .then(response => response.json())
  .then(suggestions => {
    var productSuggestions = suggestions.resources.results.products;
    displayPredictiveSearch(productSuggestions);
    if(searchBox.value !== searchTerm){
      searchJSON(searchBox.value);
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function predictiveSearch(){
  let searchTerm = searchBox.value;
  throttleFunction(searchJSON, searchTerm, 400);
}
  
// show predictive search in a drop-down
function displayPredictiveSearch(productSuggestions){
  let resultsBox = document.querySelector('.predictive-search-results');
  while(resultsBox.firstChild){
      resultsBox.removeChild(resultsBox.firstChild);
  }
  if(productSuggestions.length !== 0){
    productSuggestions.forEach(product => {
      let newProduct = document.createElement('a');
      newProduct.href = product.url;
      let newProductImage = document.createElement('img');
      newProductImage.src = getSizedImageUrl(product.image, '90x');
      let newProductTitle = document.createElement('p');
      let newProductTitleBold = document.createElement('strong');
      let newProductTitleText = document.createTextNode(product.title);
      let lineBreak = document.createElement('br');
      let newProductPrice = document.createTextNode(`${currentCurrency}` + product.price);
      newProductTitleBold.appendChild(newProductTitleText);
      newProductTitle.appendChild(newProductTitleBold);
      newProductTitle.appendChild(lineBreak);
      newProductTitle.appendChild(newProductPrice);
      newProduct.appendChild(newProductImage);
      newProduct.appendChild(newProductTitle);
      resultsBox.appendChild(newProduct);
      resultsBox.style.display = 'flex';
    })
  } else {
    resultsBox.style.display = 'none';
  }
}

// search bar toggle

var toggleSearch = document.querySelectorAll('.toggle-search');
if(searchContainer) searchContainer.classList.add('ready-to-translate');

toggleSearch.forEach(searchToggle => searchToggle.addEventListener('click', (e) => {
  toggleElement(document.querySelector('body'), e);
  document.querySelector('#search').focus();
}))

// toggle filters (mobile)
if(document.querySelector('.toggle-filters')){
  document.querySelectorAll('.toggle-filters').forEach(toggleButton => toggleButton.addEventListener('click', e => toggleElement(filters, e)));
};

// email popup

var emailPopup = document.querySelector('#email-popup')
emailPopup.classList.add('ready-to-fade')

document.querySelector('#email-popup .toggle-popup').addEventListener('click', e => {
  toggleElement(emailPopup, e)
})

function populateEmailPopup(data, e){
  document.querySelector('#email-popup .message').innerHTML = data.message
  if(data.product){
    document.querySelector('#email-popup #popup_stock_product').value = data.variant
  }
  document.querySelector('#email-popup #stock-submit').value = data.button
  if(data.image){
    document.querySelector('#email-popup img').src = data.image
  }
  
  toggleElement(emailPopup, e)
}


function popupNewsletter(click){
    localStorage.setItem('styrkr-newsletter-popup-timer', Date.now());
    let data = {
      message: 'Get 25% Off your first order! Enter your email to receive your code.',
      button: 'Sign up',
      image: 'https://cdn.shopify.com/s/files/1/0526/2547/3728/files/wellness-factory.jpg?v=1620314141'
    }
    const e = new Event('showpopup');
    if(click){
      emailPopup.classList.add('newsletter-popup');
      stockForm.style.display = 'block'
      populateEmailPopup(data, e);
    } else {
      window.onload = (event) => {
        emailPopup.classList.add('newsletter-popup');
        stockForm.style.display = 'block'
        setTimeout(function(){ populateEmailPopup(data, e); }, 5000);

      };
    }
}

// post to stocknotification.php

var stockForm = document.querySelector('.stock-form')
var stockResponse = document.querySelector('#email-popup .message')

stockForm.addEventListener('submit', e => {
  e.preventDefault();
  
  stockForm.querySelector('#stock-submit').value = "Sending...";
  
  formData = new FormData(stockForm);
  actionPath = stockForm.getAttribute("action");
  
  fetch(actionPath, {
    method: 'POST',
    body: formData,
  })
  .then(response => response.json())
  .then(data => {
    if(data.message){
      stockResponse.textContent = data.message;
      stockForm.querySelector('#stock-submit').value = "Done"
      stockForm.style.display = 'none'
      localStorage.setItem('styrkr-newsletter-status', 'registered');
    } else {
      stockResponse.innerHTML = `Sorry, there was a problem. Contact <a href="mailto:info@styrkr.com">info@styrkr.com</a> and we will add you!`;
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  
});

// cart drawer

var cartContents = document.querySelector('#cart-contents');
var firstCartOpen = true;

document.querySelectorAll('.toggle-cart').forEach(button => {
  button.addEventListener('click', e => {
    if(firstCartOpen){
      firstCartOpen = false;
      updateCart().then( ()=> toggleElement(cartDrawer, e));
    } else {
      toggleElement(cartDrawer, e);
    }
  });
});

var cartUpsellsContainer = document.querySelector('#cart-upsells-container');

if(cartUpsellsContainer){
  // add event listeners
  cartUpsellsContainer.addEventListener('click', async e => {
    if(e.target.dataset.purchaseId){
      let button = e.target;
      cartAdd(button.dataset.purchaseId, button.dataset.quantity || 1).then((response) => {
         if(response.status == 422){
           button.textContent = 'Not enough stock';
           button.style.backgroundColor = "red";
         } else {
            return updateCart();
         }
       })
       .then( ()=> {
           switchUpsellButton(button, true);
       });
    }
  })
}

// switch upsell buttons
function switchUpsellButton(button, bought) {
  let language = button.dataset.isOffer ? {bought: 'Claimed!', notBought: 'Claim offer' } : {bought: 'Added', notBought: '+ Add' }
  if(bought){
    button.textContent = language.bought;
    button.style.backgroundColor = '#ececec';
    button.style.pointerEvents = 'none';
    button.style.color = 'var(--black)';    
  } else {
    button.textContent = language.notBought;
    button.style.backgroundColor = 'var(--styrkr-orange)';
    button.style.pointerEvents = 'auto';
    button.style.color = 'white';
  }

}

// check for claimed upsells
function checkUpsellsClaimed(){
  if(cartUpsellsContainer && document.querySelector('#cart-table')){
    // get all the upsells and all the cart items and check if any should be ticked off
    document.querySelectorAll('.cart-product-upsell').forEach(upsell => {
      let button = upsell.querySelector('.shop-action');
      let productId = button.dataset.purchaseId;
      if(document.querySelector(`#cart-table tbody tr[data-variant-id="${productId}"]`)){
         switchUpsellButton(button, true);
      } else {
         switchUpsellButton(button, false);
      }
    })
  } else {
    document.querySelectorAll('.cart-product-upsell').forEach(upsell => {
      let button = upsell.querySelector('.shop-action');
      button.textContent = button.textContent === 'Claimed!' ? 'Claim offer' : button.textContent;
      button.textContent = button.textContent === 'Added' ? '+ Add' : button.textContent;
      button.style.backgroundColor = 'var(--styrkr-orange)';
      button.style.pointerEvents = 'auto';
      button.style.color = 'white';
    })
  }
}

// open cart if the query param ?cart exists
if(window.location.search.includes('cart=open')) document.querySelector('.toggle-cart').click();

// product grid setup
function productGridListeners(){
  if(document.querySelector('.product-grid')){
     document.querySelectorAll('.product-grid').forEach(productGrid => {
       productGrid.addEventListener('click', e =>{
         let button = e.target;
         let originalText = button.innerHTML;
         if(button.hasAttribute("data-purchase-id")){
           e.preventDefault();
           e.stopPropagation();
           button.style.width = button.offsetWidth + 'px';
           button.innerHTML = '<span>Adding…</span>';
           cartAdd(button.dataset.purchaseId, button.dataset.quantity || 1).then((response) => {
             if(response.status == 422){
               button.textContent = 'Not enough stock';
               button.style.backgroundColor = "red";
             } else {
                return updateCart();
             }
           })
           .then( ()=> {
               button.innerHTML = originalText;
               button.style.width = '100%';
               toggleElement(cartDrawer, e)
           });
         } else if(button.hasAttribute('data-message')){
           let data = {
             message: button.dataset.message,
             product: button.dataset.product,
             variant: button.dataset.variantId,
             button: 'Notify me',
             image: button.dataset.image
           }
           stockForm.style.display = 'block'
           emailPopup.classList.remove('newsletter-popup');
           populateEmailPopup(data, e)
         } else if(button.hasAttribute('data-href')){
            e.preventDefault();
           e.stopPropagation();
           let link = button.dataset.href;
           window.open(link, '_blank').focus();
         }
       });
    });
  }
}

productGridListeners();

var deals_response = [];

async function updateCart() {
  var cartUrl = sessionStorage.getItem('unsupported_code') == 'true' ? '/cart?view=with_code' : '/cart';
  // var geoUrl = currentCurrency === '£' ? '' : `${window.location.pathname.split('/')[1]}/`
  let batch_requests = await Promise.all([
    fetch(`/cart`),
	fetch('/apps/deals/all_deals.php')
  ]);
  let cartContent = await batch_requests[0].text();
  deals_response = await batch_requests[1].json();
  
  cartContents.innerHTML = cartContent;
  cartDrawer.scrollTop = 0;
  checkUpsellsClaimed();
  adjust_deal_prices(deals_response,true);
  cartContents.classList.remove('loading');
  initCartAdjustments();
  // set the delivery indicator bar
  let currentTotal = 0;
  if(document.querySelector('.cart-totals .total')){
    currentTotal = Number(document.querySelector('.cart-totals .total').textContent.replace(`${currentCurrency}`, '').replace('.', ''));
  }
  updateRewardsProgress(currentTotal);
//   getRecommendations();
}

function adjust_deal_prices(deals_response,first_run) {
  
  		// if subscription present, no deals
        if (document.querySelector('.cart .selling-plan-details')) {
			deals_response = [];
        }
  
  		// create copy of deals object so original is preserved
  		let deals = JSON.parse(JSON.stringify(deals_response));
  
        function remove_from_items(items, item_element) {
          let variant_id = item_element.getAttribute('data-variant-id');
          let item_index = items.findIndex(item => item.getAttribute('data-variant-id') === variant_id);
          items.splice(item_index, 1);
        }

		// initialise stuff
		let item_elements = document.querySelectorAll('.cart tr[data-variant-id]');
  
        // fix deals structure
        deals.forEach(deal => {
          deal.item_groups = [];
          deal.products.forEach(product => {
            let product_parts = product.id.split('/');
            product.id = product_parts[product_parts.length-1];
          });
        });

  		// fix item elements
		let new_item_elements = [];
        item_elements.forEach(item_element => {
          
          let item_quantity = item_element.querySelector('.quantity-number').value;
          
          if (first_run) {

            // fix item price
            item_element.setAttribute('data-price', (Number(item_element.getAttribute('data-price')) * 0.01)/item_quantity);

            // save line price (also catches subscription price)
            let existing_del = item_element.querySelector('.cart-price del');
            if (existing_del) {
              item_element.setAttribute('data-presale-price', Number(existing_del.textContent.replace(`${currentCurrency}`,'').trim())/item_quantity);
            }
            
          } else {
            
            // reset cumulative price attributes
            item_element.removeAttribute('data-true-price');
            item_element.removeAttribute('data-undiscounted-price');
          }

          // configure price elements
          let price_element = item_element.querySelector('.cart-price');
          if(price_element.querySelector('.free-tag')){
            item_element.setAttribute('data-free-tag', 'true');
          }
          price_element.childNodes.forEach(child => price_element.removeChild(child));
          price_element.textContent = '';
          price_element.appendChild(document.createElement('span'));
          
          // convert from unique array with quantity property to one entry per real world item
          for (let i = 0; i < item_quantity; i++) {
            new_item_elements.push(item_element);
          }
        });
  		item_elements = new_item_elements;

        // loop through items
  		let items_to_remove = [];
  		item_elements.forEach(item_element => {
          
			// try to find deal for this item (this code heavily relies on there only being one deal per product)
			deals.forEach(deal => {
				let item_excluded = item_element.hasAttribute('data-free-tag') || false;
				for (let product of deal.products) {
            		if (product.id === item_element.getAttribute('data-product-id')) {

						// in case of spend deal, products are excluded
						if (deal.type === 'spend') {
							item_excluded = true;
							break;
						}
					
						// try to find applicable item group
						let found_item_group = false;
						deal.item_groups.forEach(item_group => {
							if (
								(deal.type == 'stacking' || item_group.length < deal.product_count)   // either stacking (so no limit) or below limit
								&& (deal.targeting == 'group' || (item_group.length == 0 || item_group[0].getAttribute('data-variant-id') === item_element.getAttribute('data-variant-id'))) // either group (so no excluisivity) or must be same as current variants
							) {
								item_group.push(item_element);
								found_item_group = true;
							}
						});

						// add into new group if none found
						if (!found_item_group) deal.item_groups.push([item_element]);
						items_to_remove.push(item_element);
					}
				}

				// add to spend catchall group
				if (deal.type === 'spend' && !item_excluded) {
					if (deal.item_groups[0]) {
						deal.item_groups[0].push(item_element);
					} else {
						deal.item_groups.push([item_element]);
					}
                    items_to_remove.push(item_element);
				}
            });
        });
  		items_to_remove.forEach(item_element => remove_from_items(item_elements, item_element));
		
		
		// - - - - - - - - - - - - CALCULATE PRICING AND GENERATE LINE ITEMS - - - - - - - - - - - -
		
		// add mix matched line items with prices
		let line_items = [];
		let total_price = 0;
  		let total_savings = 0;

		function add_line_item(item_element, variant_price, discount_ratio = 1, discount_text = '', max = false) {
          
          	// get subelements and attribute values
			let price_element = item_element.querySelector('.cart-price span');
			let del_element = item_element.querySelector('.cart-price del');
			let upsell_element = item_element.querySelector('.cart-price .multibuy-upsell');
          	let true_price = Number(item_element.getAttribute('data-true-price'));
          	let undiscounted_price = Number(item_element.getAttribute('data-undiscounted-price'));
          	let presale_price = Number(item_element.getAttribute('data-presale-price'));
            let free_gift = item_element.getAttribute('data-free-tag');
          
          
          	// update price
          	true_price += variant_price * discount_ratio;
          	price_element.textContent = ` ${currentCurrency}` + fix_number(true_price);
          	item_element.setAttribute('data-true-price', true_price);
          
          	// update undiscounted price
          	undiscounted_price += (presale_price || variant_price);
            if (undiscounted_price !== true_price) {
                if (!del_element) {
					del_element = document.createElement('del');
                  	item_element.querySelector('.cart-price').prepend(del_element);
                }
          		del_element.textContent = `${currentCurrency}` + fix_number(undiscounted_price);
            }
          	item_element.setAttribute('data-undiscounted-price', undiscounted_price);
          
          	// update upsell
          	if (discount_text && !upsell_element) {
              upsell_element = document.createElement('span');
              upsell_element.classList.add('multibuy-upsell');
              upsell_element.textContent = discount_text;
              item_element.querySelector('.cart-price').appendChild(upsell_element);
              upsell_element.classList.toggle('max', max);
            } else if (item_element.querySelector('.selling-plan-details + .cart-price > :last-child:not(.subscription)')) {
              
              // item is on subscription but last price element is not the subscription badge
              upsell_element = document.createElement('span');
              upsell_element.classList.add('multibuy-upsell', 'max', 'subscription');
              upsell_element.textContent = 'Subscription';
              item_element.querySelector('.cart-price').appendChild(upsell_element);
            }

            // add free tags back
            if(free_gift === 'true'){
              upsell_element = document.createElement('span');
              upsell_element.classList.add('free-tag');
              upsell_element.textContent = 'Free gift!';
              item_element.querySelector('.cart-price').appendChild(upsell_element);
            }
          
            // update totals
            total_price += variant_price * discount_ratio;
            total_savings += (presale_price || variant_price) - (variant_price * discount_ratio); // most expensive - least expensive
          
		}
  
  		let any_products_discounted = false;

		// add deal line items
  		deals.forEach(deal => {

			let spend_deal_total = 0;
			let active_spend_discount;
			let next_spend_discount;

            // redistribute cheap/expensive items evenly across item groups and sort by price, meaning most expensive items will get discounted
            if (deal.targeting == 'group' && deal.type == 'bogof') {

                // get all items 
                let deal_items = deal.item_groups.flat();

                // sort by price
                deal_items.sort((a, b) => Number(a.getAttribute('data-price')) - Number(b.getAttribute('data-price')));

                let complete_item_groups = Math.floor(deal_items.length / deal.product_count);

				let new_item_groups = [];
                deal_items.forEach((deal_item, deal_item_index) => {

                  	let item_group_index;
					if (deal_item_index + 1 > deal.product_count * complete_item_groups) {

						// add to final group for most remainder non layered (most expensive) items
						item_group_index = complete_item_groups;

					} else {

						// layer like vienetta across groups
						item_group_index = deal_item_index % complete_item_groups;
					}
                  
                    // create item group and add to it
                    if (new_item_groups[item_group_index]) {
                        new_item_groups[item_group_index].push(deal_item);
                    } else {
                        new_item_groups[item_group_index] = [deal_item];
                    }

                });

                deal.item_groups = new_item_groups;

            } else if (deal.type === 'spend') {

				// compute total price of items
                if (deal.item_groups[0]) {
    				for (let item_element of deal.item_groups[0]) {
    					spend_deal_total += Number(item_element.getAttribute('data-price'));
    				}
                } 
			}
				
			deal.item_groups.forEach(item_group => {
				
				item_group.forEach((item_element, item_index) => {
                  
					let variant_price = Number(item_element.getAttribute('data-price'));

                    // set discount ratio and text (for applied deals only) if group reached product count
                  	let discount_ratio = 1;
                  	let discount_text = '';
                  	let max = false;
                    if (item_group.length >= deal.product_count) {

                        if (deal.type == 'bogof') {

                            // no of items discounted minus position from start of group
                            discount_ratio = 1 - Math.min(Math.max(deal.discount - item_index, 0), 1);
                          
                          	// bogof active so show deal name
                          	discount_text = deal.friendly_type;
                          
                          	max = true;

                        } else if (deal.type == 'stacking') {

                            // set discount based off deal discount, stacking limit, group count
                          	discount_ratio = 1 - (deal.discount * Math.min(item_group.length, deal.stacking_limit));
                          
                        } else if (deal.type === 'spend') {
							// set according to deal total and discount array (data structure TBC)
							for (let s = 0; s < deal.spend_discounts.length; s++) {
								if (spend_deal_total >= deal.spend_discounts[s].spend) {
									discount_ratio = 1 - deal.spend_discounts[s].discount;
									active_spend_discount = deal.spend_discounts[s];
									next_spend_discount = deal.spend_discounts[s+1];
								}
							}
                            // ensures tag is added if below the first deal threshold
                            if(!next_spend_discount && (deal.spend_discounts[deal.spend_discounts.length - 1].spend > spend_deal_total)){
                              next_spend_discount = deal.spend_discounts[0];
                            }
						}
                    }
                  
                  	// log if any products have been discounted
                  	if (discount_ratio !== 1) any_products_discounted = true;
                  
                  	// set generic and unapplied discount text
                  	if (!discount_text) {
                      
                      if (deal.type == 'bogof') {
	
                        // buy one get one free
                        if (deal.product_count == 2 && deal.discount == 1) {
                          discount_text = 'Add 1 for free?';
                          
                        // buy one get one half price
                        } else if (deal.product_count == 2 && deal.discount == 0.5) {
                          discount_text = 'Buy 1 get 1 half price ';
                        
                        // 3 for 2
                        } else if (deal.product_count == 3 && deal.discount == 1) {
                          discount_text = 'Add more, get 3 for 2';
                        }

                      } else if (deal.type == 'stacking') {

                        // round to .5s via *2)/2
                        if (item_group.length >= deal.stacking_limit) {
                          discount_text = (Math.trunc(0.0001 + (1-discount_ratio)*100*2)/2)+'% discount applied';
                          max = true;
                        } else {
                          discount_text = 'Add 1 more for '+(Math.trunc(0.0001 + deal.discount * 100 * (item_group.length + 1) * 2) / 2)+'% off';
                        }
                      } else if (deal.type === 'spend') {
						max = true;
						if (next_spend_discount) {
							discount_text = 'Spend '+currentCurrency+fix_number(next_spend_discount.spend - spend_deal_total)+' to get '+(Math.trunc(0.0001 + next_spend_discount.discount*100*2)/2)+'% off';
						} else if (active_spend_discount) {
							discount_text = (Math.trunc(0.0001 + active_spend_discount.discount*100*2)/2)+'% discount applied';
						}
					  }
                    }
                      
                    // add to line items
                    
                    add_line_item(item_element, variant_price, discount_ratio, discount_text, max)
                  
                  	// update upsells on other items in group
                  	if (deal.targeting == 'group' && discount_ratio == 1 && discount_text && max == false) {
                    	deal.item_groups.forEach(upsell_item_group => {
							upsell_item_group.forEach(upsell_item_element => {
                              	let upsell_element = upsell_item_element.querySelector('.multibuy-upsell');
                                if(upsell_element){
                                  upsell_element.textContent = discount_text;
                                  upsell_element.classList.toggle('max', false);
                                }
                            });
                        });
                    }
                  
				});
			});
		});
		
		// add remaining (ungrouped) line items - stripped out version of above
		item_elements.forEach(item_element => {
			
			// add to total price for later
			let variant_price = Number(item_element.getAttribute('data-price'));
					
			add_line_item(item_element, variant_price);
		});
  
  		let total_element = document.querySelector('.cart-totals .total');
        if(total_element){
          total_element.textContent = `${currentCurrency}`+fix_number(total_price);
          total_element.setAttribute('data-before-discount',total_price);
        }

        // update total items
        if(document.querySelector('#cart-contents form')){
          document.querySelector('.cart-count-number').textContent = document.querySelector('#cart-contents form').dataset.itemCount;
        }
  
  		// remove any existing savings elements and add new
          document.querySelectorAll('.cart-totals .savings').forEach(el => el.parentElement.removeChild(el));
  
  		  if (total_savings) {
            let savings_element = document.createElement('span');
            savings_element.classList.add('savings');
            savings_element.setAttribute('data-before-discount',total_savings);
            document.querySelector('.cart-totals').append(savings_element);
            savings_element.textContent = `${currentCurrency}` + fix_number(total_savings, true);
  			total_element.setAttribute('data-illustrative-full-price', `${currentCurrency}` + fix_number(total_price + total_savings));
          } else if (total_element) {
  			total_element.removeAttribute('data-illustrative-full-price');
          }
  
  
  		// set correct checkout
  		let checkout_button = document.querySelector('.cart-actions [name="checkout"]');
        if (checkout_button) {
          checkout_button.toggleAttribute('data-deals-applied',any_products_discounted);
        }
}

// cart adjustments event listeners

function initCartAdjustments(){
  if(document.querySelector('.cart-adjustments')){
    document.querySelectorAll('.cart-adjustments, .cart-price').forEach(adjustment => {
      adjustment.addEventListener('click', (e) => { 
        e.preventDefault();
        e.stopPropagation();
        var quantityInput = e.target.closest('tr').querySelector('.quantity-number');
        var currentValue = parseInt(quantityInput.value);
        var clicked = e.target.classList;
        var hasChanged = false;
        var newValue;
        switch( true ){
          case clicked.contains('quantity-minus'):
            quantityInput.value = currentValue - 1;
            newValue = quantityInput.value;
            hasChanged = true;
            break;
          case clicked.contains('quantity-plus'):
            quantityInput.value = currentValue + 1;
            newValue = quantityInput.value;
            hasChanged = true;
            break;
          case clicked.contains('cart-remove-button'):
            quantityInput.value = 0;
            newValue = quantityInput.value;
            hasChanged = true;
            break;
            
          // beware multibuy gets recreated so listener is on parent
          case !!e.target.closest('.multibuy-upsell:not(.max)'):
            quantityInput.value = currentValue + 1;
            newValue = quantityInput.value;
            hasChanged = true;
            break; 
        }
        // get new value and update cart
        if(hasChanged){
          cartContents.classList.add('loading');
          e.target.blur();
          var lineId = e.target.closest('tr').dataset.lineId;
          cartChange(lineId,newValue).then((response) => {
                return updateCart();
             })
          };
      });
    })
  }
  let continue_button = document.querySelector('.continue-shopping');
  if (continue_button) {
    continue_button.addEventListener('click', e => {
      toggleElement(cartDrawer, e);
    });
  }
  if(document.querySelector('.cart-actions [name="checkout"]')){
    document.querySelector('.cart-actions [name="checkout"]').addEventListener('click', e => {
      localStorage.setItem('checked_out_from', location.href);
      let discount_code_element = document.querySelector('#discount-code');
      if (e.target.hasAttribute('data-deals-applied')) {
        e.preventDefault();
        e.stopPropagation();
        submitMultibuyCheckout();
      } else if (discount_code_element && discount_code_element.value) {
        window.location.href = '/checkout?discount='+encodeURIComponent(discount_code_element.value);
        e.preventDefault();
        e.stopPropagation();
      }
    });
  }
  if(document.querySelector('#discount-code')){
     initDiscountCodes();
  }
}

// delivery/upsell target indicator

var progressBar = document.querySelector('.progress-indicator');
var deliveryTargetNotice = document.querySelector('.delivery-target-notice');

async function updateRewardsProgress(totalInput){
  // sometimes totalInput has a decimal so we fix:
  let total = Number(String(totalInput).replace('.', ''));
  if(progressBar){
    // get JSON data
    let markersData = JSON.parse(document.querySelector('#markers-data').innerHTML).upsells;
    if(markersData.length < 1){
      return;
    }
    markersData.sort((a, b) => a.threshold - b.threshold);
    let maxValue = Math.max(...markersData.map(marker => marker.threshold))
    let incompleteRewards = [];
    if(document.querySelector('form.cart')){
      // get the cart and work out if gifts need to be added or remvoed
      let cartItems = [...document.querySelectorAll('#cart-table tbody tr')].map(cartItem => Number(cartItem.dataset.variantId));

      // get all free gift items and remove any that aren't currently set as a marker
      let currentFreeGifts = [...document.querySelectorAll('#cart-table tbody tr')].reduce((filtered, cartItem) => {
        if (cartItem.dataset?.freeTag === 'true') {
           let freeItem = cartItem.dataset.variantId
           filtered.push(freeItem);
        }
        return filtered;
      }, []);

      let productsToAdd = [];
      let productsToRemove = [];
      markersData.forEach(marker => {
        // this is all for completed markers
        if(totalInput > marker.threshold){
          document.getElementById(marker.id).classList.add('completed');
          // if completed marker is a free gift, add it to the cart
          if(marker.type === 'gift'){
            if(!cartItems.includes(marker.product)){
              productsToAdd.push(marker.product);
            }
          }
        } else {
          // not completed
          document.getElementById(marker.id).classList.remove('completed');
          incompleteRewards.push(marker);
          // if not completed and free gift check the cart out
          if(marker.type === 'gift'){
            if(cartItems.includes(marker.product)){
              // remove it from the cart
              productsToRemove.push(document.querySelector(`#cart-table tbody tr[data-variant-id="${marker.product}"]`).dataset.lineId);
            }
          }
        }
      })

      // extra step to remove invalid free gifts
      currentFreeGifts.forEach(freeGift => {
        let isValid = markersData.some(marker => {
          return (marker.type === 'gift' && marker.product === Number(freeGift));
        })
        if(!isValid) productsToRemove.push(document.querySelector(`#cart-table tbody tr[data-variant-id="${freeGift}"]`).dataset.lineId);
      })

      // find the next incomplete reward to create a target next spend
      let nextReward = null;
      if(incompleteRewards.length > 0){
        nextReward = incompleteRewards.reduce((prev, curr) => prev.threshold < curr.threshold ? prev : curr);
      } else {
        // calculate progress towards phantom 'end of bar'
        let scaleVal = 0;
        scaleVal = ((totalInput - markersData[markersData.length - 1].threshold) / ((maxValue + 5000) - markersData[markersData.length - 1].threshold)) * (1 / (markersData.length + 1));
        scaleVal = scaleVal + (markersData.length / (markersData.length + 1));  
        setTimeout(function(){ progressBar.style.transform = 'scaleX(' + scaleVal + ')'; }, 600);
        deliveryTargetNotice.textContent = "You've earned all our basket rewards today!";
      }
      
      // if over the highest reward
      if(nextReward){
        // get the right target text to show the customer
        // funky version with non-linear scale for evenly distributed targets
        let targetIndex = markersData.indexOf(nextReward);
        let previousIndex = targetIndex - 1;
        // if there is no previous one, we just need the scale of the first section
        let scaleVal = 0;
        if(targetIndex < 1){
          scaleVal = (totalInput / markersData[targetIndex].threshold) * (1 / (markersData.length + 1));
          scaleVal = scaleVal + (targetIndex / (markersData.length+ 1));  
        } else {
          scaleVal = ((totalInput - markersData[previousIndex].threshold) / (markersData[targetIndex].threshold - markersData[previousIndex].threshold)) * (1 / (markersData.length + 1));
          scaleVal = scaleVal + (targetIndex / (markersData.length + 1));         
        }

        setTimeout(function(){ progressBar.style.transform = 'scaleX(' + scaleVal + ')'; }, 600);
        deliveryTargetNotice.innerHTML = `<strong>Add ${currentCurrency}${((nextReward.threshold - totalInput) / 100).toFixed(2)}</strong> ${nextReward.customerSnippet}`;
      }

      // add any products
      if(productsToAdd.length > 0){
        // we need to add the gift to the cart
        cartContents.classList.add('loading');
        let addItems = [];
        productsToAdd.forEach(product => {
          addItems.push({
            id: product,
            quantity: 1,
          })
        })
        
        cartAddMultiple(addItems).then((response) => {
          if(response.status == 422){
            console.log('no stock of free gift');
          } else {
            return updateCart();
          }
        })
      }
      
      // remove any products
      if(productsToRemove.length > 0){
        cartContents.classList.add('loading');
        await Promise.all(productsToRemove.map(async (product) => {
          await cartChange(product,0)
        }));

        return updateCart();
        
      }
    } else {
        setTimeout(function(){ progressBar.style.transform = 'scaleX(0)'; }, 600);
        deliveryTargetNotice.textContent = `Add ${currentCurrency}50 for free UK delivery`;
    }
  }
}


// recommended products

async function getRecommendations(){
  var recommendationsContainer = document.querySelector('#product-recommendations');
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  var firstCartItem = document.querySelector('.cart tr:first-of-type');
  if(firstCartItem){
    var productId = firstCartItem.dataset.productId;
    var response = await fetch('/recommendations/products?section_id=cart-product-recommendations&product_id=' + productId + '&limit=6');
    var recommendations = await response.text();
    recommendationsContainer.innerHTML = recommendations;
    recommendationsContainer.querySelectorAll('.cart-recommendations-add').forEach( button => {
      button.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        var button = e.target;
        if(button.hasAttribute("data-purchase-id")){
          cartContents.classList.add('loading');
           cartAdd(button.dataset.purchaseId ,1).then((response) => {
               return updateCart();
           });
        };
      });
    });
  }
}

// send to draft order

async function submitMultibuyCheckout(){
  
  let data = {
    items: []
  };

  // add all items
  document.querySelectorAll('.cart > table tr[data-product-id]').forEach(item => {
    data.items.push({
      "product_id": item.getAttribute('data-product-id'),
      "variant_id": item.getAttribute('data-variant-id'),
      "quantity": item.querySelector('input[type="number"]').value
    });
  });
  
//   let supported_discount = JSON.parse(sessionStorage.getItem('supported_discount'));
//   if (supported_discount){
//     data.price_rule_id = supported_discount.price_rule_id;
//     data.discount_code_id = supported_discount.discount_code_id;
    
//   }

  // send
  window.location.href = '/apps/deals/deals_checkout.php?json='+encodeURIComponent(JSON.stringify(data));
      
}

// prepare discount codes input
function initDiscountCodes() {
	// discount code typing listener
	var discount_code_element = document.querySelector('input#discount-code');
	if (discount_code_element) {

		var discount_message_element = document.querySelector('.discount-message');
        var discount_clear_element = document.querySelector('.discount-code-input span.clear');
		var discount_code_timeout;
	  
		async function check_discount_code(input_value) {
          
            // get from session if is already cached response
            let discount_code_response = JSON.parse(sessionStorage.getItem('discount_code_response'));
            if (!discount_code_response || discount_code_response.code !== input_value) {

              // send code to app
              let response = await fetch('/apps/deals/validate_discount_code.php', {
                  method: 'POST',
                  headers: {'Content-Type': 'application/json'},
                  body: JSON.stringify({"discount_code": input_value})
              });

              discount_code_response = {
                code: input_value,
                ok: response.ok,
                status: response.status,
                body: response.status === 200 ? await response.json() : ''
              };
            }
								
			// check value hasn't changed
			if (input_value == discount_code_element.value.trim()) {
             
              	// save to session
              	sessionStorage.setItem('discount_code_response', JSON.stringify(discount_code_response));

				// code is valid
				if (discount_code_response.ok) {

					// code is accepted by deals app
					if (discount_code_response.status == 200) {
						discount_message_element.textContent = 'Success! Please enter this code at checkout.\r\nNote: offer not valid with our Multibuy Deals.';
                      	let supported_discount = discount_code_response.body;
//                       	sessionStorage.setItem('supported_discount', JSON.stringify(supported_discount));
						applyDiscount(supported_discount);

					// code is unsupported
					} else if (discount_code_response.status == 202) {
						discount_message_element.textContent = 'Success! Please enter this code at checkout.\r\nNote: offer not valid with our Multibuy Deals.';
						applyDiscount(null);
					}

					discount_code_element.classList.add('success');
					
				} else {

					//code is invalid
					if (discount_code_response.status == 404) {
						discount_message_element.textContent = 'Sorry, code not found. If your code is a gift card, please apply it during checkout.';
					} else if (discount_code_response.status == 410 ) {
						discount_message_element.textContent = 'Sorry, this code has expired';
					} else if (discount_code_response.status == 403) {
						discount_message_element.textContent = 'Sorry, this code has been used';
					}
					applyDiscount();
				}
			}
			discount_code_element.classList.remove('loading');
			document.querySelector('#cart-contents').classList.remove('loading');
		};
      
      	let input_updated = e => {

			// update and get stuff
			clearTimeout(discount_code_timeout);
			discount_code_element.classList.remove('success', 'loading');
			let discount_code = discount_code_element.value.trim();
// 			sessionStorage.removeItem('supported_discount');
			discount_message_element.textContent = '';
          	discount_clear_element.classList.remove('show');
          
			applyDiscount();
          
            discount_clear_element.classList.toggle('show', discount_code);
          	
			// if code, set loading classes and run check code after a delay
			if (discount_code) {
                discount_clear_element.classList.add('show');
				discount_code_element.classList.add('loading');
				document.querySelector('#cart-contents').classList.add('loading');
				discount_code_timeout = setTimeout(() => check_discount_code(discount_code),700);
            } else {
          		sessionStorage.removeItem('discount_code_response');
            }

		};
	  
		discount_code_element.addEventListener('input', input_updated);
      
        // clear button
        discount_clear_element.addEventListener('click', e => {
          discount_code_element.value = '';
		  input_updated(e);
        });
      
        // block enter behaviour
        discount_code_element.addEventListener('keydown',e => {
            if (e.key == 'Enter') {
                e.preventDefault();
                e.stopPropagation();
            }
        });

        // check if discount was already applied, and re-apply it
        let discount_code_response = JSON.parse(sessionStorage.getItem('discount_code_response'));
        if (discount_code_response) {
            discount_code_element.value = discount_code_response.code;
            check_discount_code(discount_code_response.code);
          	discount_clear_element.classList.add('show');
        }
	}
}
  
function applyDiscount(discount) {

  	// if discount exists (null = unsupported) calc with no deals
  	adjust_deal_prices(discount === undefined ? deals_response : [], false);

	let total_element = document.querySelector('.cart-totals .total');
	let savings_element = document.querySelector('.cart-totals .savings');
  	let total = Number(total_element.getAttribute('data-before-discount'));
  	let savings = savings_element ? Number(savings_element.getAttribute('data-before-discount')) : 0;
  
	if (discount) {

		// if min spend not reached, add message and abort
		if (discount.min_spend > total) {
			document.querySelector('.discount-message').textContent = `Spend ${currentCurrency}` +fix_number(discount.min_spend) + ' to qualify';
			return;
		}
		
		let newTotal = total;
		let newSavings = savings;

		// percentage discounts
		if (discount.value_type == 'percentage') {
			let discountPercent = discount.value/100;
			newTotal = (total -  (total * discountPercent));
			newSavings = (savings + (total * discountPercent));
		
		// fixed value discounts
		} else if (discount.value_type == 'fixed_amount') {
			newTotal = (total -  discount.value);
			newSavings = (savings + discount.value);
		}
      
      	// create savings element if needed
        if (!savings_element) {
          savings_element = document.createElement('span');
          savings_element.classList.add('savings');
          document.querySelector('.cart-totals').append(savings_element);
        }

		// apply values
		total_element.textContent = `${currentCurrency}` + fix_number(newTotal);
		savings_element.textContent = `${currentCurrency}` + fix_number(newSavings, true);
      	total_element.setAttribute('data-illustrative-full-price', `${currentCurrency}` + fix_number(newTotal + newSavings));
		
    } else {
      
    	// unapply discount
		total_element.textContent = `${currentCurrency}` + fix_number(total);
        if (savings) {
      	  savings_element.textContent = savings ? `${currentCurrency}` + fix_number(savings, true) : '';
          total_element.setAttribute('data-illustrative-full-price', `${currentCurrency}` + fix_number(total + savings));
        } else {
          total_element.removeAttribute('data-illustrative-full-price');
          if (savings_element) savings_element.remove();
        }
        
    }

  updateRewardsProgress(Number(document.querySelector('.cart-totals .total').textContent.replace(`${currentCurrency}`, '').replace('.', '')));
}

// rounds up to pence and fixes to two decimal places
function fix_number(value, force_floor) {
  
  // cut off any floating point weirdness
  value = Math.round(value*10000)/10000;
  
  return (Math[force_floor ? 'floor' : 'ceil'](value*100)/100).toFixed(2);
//   return (Math.round(value*100)/100).toFixed(2);
//   return (Math.ceil(value*100)/100).toFixed(2);
}

// open cart if checked out from here
if (localStorage.getItem('checked_out_from') === location.href) {
  localStorage.removeItem('checked_out_from');
  document.querySelector('.toggle-cart').click();
}

// cookie notice

var cookieNotice = document.querySelector('#cookie-notice');
  
if (localStorage.getItem('cookieSeen') != 'shown') {
  cookieNotice.classList.add('visible');

};
  
cookieNotice.querySelector('.button').addEventListener('click', () =>{
 cookieNotice.classList.remove('visible');
  localStorage.setItem('cookieSeen','shown');                                         
});

// submit newsletter

var newsletterForm = document.querySelector('.newsletter-form');
var newsletterResponse = document.querySelector('#signup-response');

newsletterForm.addEventListener('submit', e => {
  e.preventDefault();
  
  newsletterForm.querySelector('#newsletter-signup').value = "Adding...";
  
  formData = new FormData(newsletterForm);
  actionPath = newsletterForm.getAttribute("action");
  
  fetch(actionPath, {
    method: 'POST',
    body: formData,
  })
  .then(response => response.json())
  .then(data => {
    if(data.email){
      newsletterResponse.textContent = "Thanks – we've added " + data.email + " to the STYRKR mailing list."
      newsletterResponse.style.display = 'block';
      newsletterForm.style.display = 'none';
      localStorage.setItem('styrkr-newsletter-status', 'registered');
    } else {
      newsletterResponse.innerHTML = `Sorry, there was a problem Contact <a href="mailto:info@styrkr.com">info@styrkr.com</a> and we will add you!`;
      newsletterResponse.style.display = 'block';
      newsletterForm.style.display = 'none';
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  
});



// get instagram

if(document.querySelector('.instagram-panel:not(.instagram-landing-page)')){
  
  var instaLimit = 1
  var reachedLimit = false
  var instaContainer = document.querySelector('.instagram-slider')
  
  let path = '/apps/styrkr/instagram.php'
  
  var lazyLoadInsta = (entries, observer) => {
    entries.forEach(entry => {
      if(entry.isIntersecting){
        let instagramImages = instaContainer.querySelectorAll('img[data-lazy]')
        instagramImages.forEach(image => instaObserver.observe(image));
      }
    });
  };
  
  var instaObserverContainer = new IntersectionObserver(lazyLoadInsta, {
    root: null,
    rootMargin: '0px 0px 400px 0px',
    threshold: 0
  });
  
  
  var instaObserver = new IntersectionObserver(lazyLoad, {
    root: instaContainer,
    rootMargin: '0px 500px 0px 0px',
    threshold: 0
  });
  
  instaObserverContainer.observe(instaContainer)

  
   fetch(path, {
     method: 'GET',
   })
  .then(response => response.json())
  .then(data => {
     let instaData = JSON.parse(data)
     instaData.data.forEach(image => {
       if(image.media_type == 'CAROUSEL_ALBUM'){
         addInstaImage(image, false)
         // with all carousel children image.children.data.forEach( image => addInstaImage(image, false) )
       } else if(image.media_type == 'IMAGE'){
         addInstaImage(image, false)
       } else if(image.media_type == 'VIDEO'){
         addInstaImage(image, true)
       }

     })
  })
  .catch((error) => {
    console.error('Error:', error)
  })
   
  function addInstaImage(image, video){

    if(instaLimit < 6){

      let img = video ? image.thumbnail_url : image.media_url

      let url = image.permalink

      let newImageLink = document.createElement('a')
      newImageLink.classList.add('instagram-slide')
      newImageLink.classList.add('cell')
      newImageLink.target = "_blank"
      newImageLink.href = url
      let newImage = document.createElement('img')
      newImage.classList.add('instagram-image')
      newImage.height = 300
      newImage.width = 300
      newImage.src = 'https://cdn.shopify.com/s/files/1/0551/0388/1250/files/styrkr-insta-profile_150x150_crop_center.jpg?v=1637783324'
      newImage.dataset.lazy = ''
      newImage.dataset.src = img
      newImage.alt = 'Follow STYRKR on Instagram'
      newImageLink.appendChild(newImage)
      instaContainer.appendChild(newImageLink)

      instaLimit++

    } else if(reachedLimit == false){

      let instaSpacer = document.createElement('a')
      instaSpacer.classList.add('insta-spacer')
      let spacerLink = document.createElement('span')
      let spacerText = document.createTextNode('View more on instagram')
      spacerLink.appendChild(spacerText)
      instaSpacer.href = "https://www.instagram.com/styrkr.uk"
      instaSpacer.appendChild(spacerLink)
      instaContainer.appendChild(instaSpacer)

       reachedLimit = true
    }
  }  
   
}